
function ItemFilter({ text, value, setValue }) {
    return (
        <div className='mx-8 p-2 flex flex-row-reverse items-center'>
            <p className="text-sm">{text}</p>
            <input
                placeholder='جستجو'
                className='text-right text-sm border border-slate-200 rounded p-1 pr-2 mr-1'
                value={value}
                onChange={(e) => setValue(e.target.value)}
            />
        </div>
    )
}
export default ItemFilter;